
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {ApiGateway as ApiGatewayService} from "@/simulation/ApiGateway";

    @Component
    export default class ApiGateway extends Vue {
        @Prop() private apiGateway!: ApiGatewayService;
    }
